<div
  class="max-w-screen-xl p-6 mx-auto shadow-lg animate-slide-in-left bg-white/80 backdrop-blur-md rounded-xl">
  <!-- En-tête -->
  <div class="flex items-center justify-between mb-8">
    <h1
      class="inline-flex items-center justify-center px-5 py-1 text-2xl font-medium text-gray-800 cursor-pointer me-2 focus:text-blue-700 hover:text-gray-600">Gestion
      des
      Utilisateurs</h1>
    <div class="flex items-center space-x-4">
      <div class="px-4 py-2 bg-green-100 rounded-lg dark:bg-green-900">
        <span
          class="font-medium text-green-200 ">Utilisateurs
          actifs: {{ usersActif }}</span>
      </div>
      <button
        class="px-4 py-2 text-white transition bg-gray-600 rounded-lg hover:bg-gray-800"
        routerLink="/utilisateurs/ajout">
        Ajouter un utilisateur
      </button>
    </div>
  </div>

  <div class="flex flex-col gap-6 md:flex-row">
    <!-- Colonne 1 - Liste des utilisateurs -->
    <div class="flex-1">
      <div class="p-4 bg-white rounded-lg shadow ">
        <h2
          class="mb-4 text-lg font-semibold text-gray-800 ">Liste
          des Inspecteurs</h2>

        <div class="overflow-x-auto">
          <table
            class="min-w-full divide-y divide-gray-400">
            <thead class="bg-gray-400 ">
              <tr>
                <th
                  class="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-200">Nom</th>
                <th
                  class="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-200">Rôle</th>
                <th
                  class="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-200">Statut</th>
                <th
                  class="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-200">Actions</th>
              </tr>
            </thead>
            <tbody
              class="bg-white divide-y divide-gray-400 ">
              <!-- Exemple d'utilisateur -->
              <tr *ngFor="let user of paginatedUsers" (click)="selectUser(user)"
                class="cursor-pointer hover:bg-gray-400/80 backdrop-blur-md">
                <td
                  class="px-4 py-3 text-sm font-medium text-gray-900 whitespace-nowrap ">{{user.nom}}
                  {{ user.prenom }}</td>
                <td
                  class="px-4 py-3 text-sm text-gray-500 whitespace-nowrap ">{{
                  user.role }}</td>
                <td class="px-4 py-3 whitespace-nowrap">
                  <span
                    class="inline-flex px-2 text-xs font-semibold leading-5 rounded-full"
                    [ngClass]="user.active
    ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
    : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'">
                    {{ user.active?"Actif":"Inactif" }}
                  </span>
                </td>
                <td
                  class="px-4 py-3 text-sm text-gray-500 whitespace-nowrap ">
                  <button
                    class="mr-2 hover:text-white text-white  focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center bg-gray-800 hover:bg-gray-600 focus:ring-gray-700"
                    (click)="editUser(user)">Éditer</button>
                  <button
                    [ngClass]="!user.active
      ? 'bg-green-500 hover:bg-green-600 focus:ring-green-300 dark:bg-green-700 dark:hover:bg-green-800 dark:focus:ring-green-900 text-white'
      : 'bg-red-500 hover:bg-red-600 focus:ring-red-300 dark:bg-red-700 dark:hover:bg-red-800 dark:focus:ring-red-900 text-white'"
                    class="mr-2 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                    (click)="showConfirmationModal = true">
                    {{ user.active ? 'Désactiver' : 'Activer' }}
                  </button>

                </td>
              </tr>
              <!-- Autres utilisateurs... -->
            </tbody>
          </table>
        </div>

        <div class="flex items-center justify-between mt-4">
          <div class="text-sm text-gray-500 ">
            Affichage {{ (currentPage - 1) * itemsPerPage + 1 }} -
            {{ Math.min(currentPage * itemsPerPage, usersInspecteur.length) }}
            sur {{ usersInspecteur.length }} utilisateurs
          </div>
          <div class="flex space-x-1">
            <button
              class="px-3 py-1 text-gray-700 bg-gray-200 rounded cursor-pointer"
              [disabled]="currentPage === 1"
              (click)="currentPage = currentPage - 1">&lt;</button>

            <button
              *ngFor="let page of [].constructor(totalPages); let i = index"
              class="px-3 py-1 rounded cursor-pointer"
              [ngClass]="{
                            'text-white bg-gray-800': currentPage === i + 1,
                            'text-gray-700  bg-gray-600 ': currentPage !== i + 1
                          }"
              (click)="currentPage = i + 1">
              {{ i + 1 }}
            </button>
            <button
              class="px-3 py-1 text-gray-700 bg-gray-200 rounded cursor-pointer ">&gt;</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Ligne verticale séparatrice -->
    <div *ngIf="selectedUser"
      class="hidden h-auto border-l border-gray-600 md:block"></div>

    <!-- Colonne 2 - Statistiques -->
    <div
      class="w-full pt-6 border-t border-gray-600 md:w-1/3 md:pt-0 md:border-t-0 md:border-l"
      *ngIf="selectedUser">
      <div class="p-4 bg-gray-400 rounded-lg shadow ">
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-lg font-semibold text-white">
            Statistiques
          </h2>
          <button (click)="selectedUser = null"
            class="mr-2  hover:text-white text-white bg-yellow-500  focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center  dark:focus:ring-yellow-700">
            Fermer les détails
          </button>
        </div>
        <!-- Carte Statistiques générales -->
        <div class="mb-6">
          <h3 class="mb-2 font-medium text-white">Activité
            globale</h3>
          <div class="grid grid-cols-2 gap-4">
            <div class="p-3 rounded-lg bg-blue-900/30">
              <p class="text-sm text-blue-200">Rapports
                créés</p>
              <p
                class="text-2xl font-bold text-blue-300">{{
                nombreRapportInspectionCree }}</p>
            </div>
            <div class="p-3 rounded-lg bg-green-900/30">
              <p class="text-sm text-green-200">Cartes
                générées</p>
              <p
                class="text-2xl font-bold text-green-300">{{
                nombreBadgeCree }}</p>
            </div>
          </div>
        </div>

        <!-- Carte Utilisateur sélectionné -->
        <div class="mb-6">
          <h3 class="mb-2 font-medium text-white">Détails
            utilisateur</h3>
          <div class="p-4 bg-gray-600 rounded-lg">
            <div class="flex items-center mb-3">
              <div
                class="flex items-center justify-center w-10 h-10 mr-3 bg-blue-900 rounded-full">
                <span
                  class="font-medium text-blue-600 dark:text-blue-300">{{
                  selectedUser?.nom.substring(0, 1).toUpperCase() }}{{
                  selectedUser?.prenom.substring(0, 1).toUpperCase()
                  }}</span>
              </div>
              <div>
                <h4 class="font-medium text-white ">{{
                  selectedUser?.nom }} {{ selectedUser?.prenom }} |</h4>
                <p
                  class="text-xs text-gray-500 dark:text-gray-300">{{
                  selectedUser?.role }}</p>
              </div>
            </div>

            <div class="space-y-3">
              <div>
                <p class="text-sm text-white ">Rapports
                  créés: <span
                    class="font-medium text-blue-600 ">{{
                    nombreRapportInspectionCree }}</span></p>
                <div
                  class="w-full h-2 mt-1 bg-gray-200 rounded-full dark:bg-gray-500">
                  <div class="h-2 bg-blue-600 rounded-full"
                    [style.width.%]="rapportPourcentage"></div>
                </div>
                <span class="ml-2 text-xs text-blue-500">
                  {{ rapportPourcentage | number: '1.0-0' }}%
                </span>
              </div>
              <div>
                <p class="text-sm text-white">Cartes
                  générées: <span
                    class="font-medium text-green-600 dark:text-green-300">{{
                    nombreBadgeCree }}</span></p>
                <div
                  class="w-full h-2 mt-1 bg-gray-200 rounded-full dark:bg-gray-500">
                  <div class="h-2 bg-green-600 rounded-full"
                    [style.width.%]="badgePourcentage"></div>
                </div>
                <span class="ml-2 text-xs text-green-500">
                  {{ badgePourcentage | number: '1.0-0' }}%
                </span>
              </div>
              <div>
                <p class="text-sm text-white">dernière
                  Activité: {{ lastHour ? (lastHour | date:'short') : 'Dormant!'
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Carte Actions rapides -->
        <!-- <div>
          <h3 class="mb-2 font-medium text-gray-700 dark:text-gray-300">Actions
            rapides</h3>
          <div class="space-y-2">
            <button
              class="flex items-center justify-between w-full px-4 py-2 transition bg-gray-100 rounded-lg dark:bg-gray-600 hover:bg-gray-200 dark:hover:bg-gray-500">
              <span>Exporter les données</span>
              <svg class="w-5 h-5 text-gray-500 dark:text-gray-300" fill="none"
                stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
              </svg>
            </button>
            <button
              class="flex items-center justify-between w-full px-4 py-2 transition bg-gray-100 rounded-lg dark:bg-gray-600 hover:bg-gray-200 dark:hover:bg-gray-500">
              <span>Voir les logs</span>
              <svg class="w-5 h-5 text-gray-500 dark:text-gray-300" fill="none"
                stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
            </button>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>

<div *ngIf="showConfirmationModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="p-6 bg-white border border-gray-200 rounded-lg shadow-lg w-96">
    <h3 class="mb-4 text-xl font-semibold text-gray-800">Confirmer l'action</h3>
    <p class="text-gray-600">
      Êtes-vous sûr de vouloir vous {{ selectedUser.active?"Désactivé":"Activé"
      }} cet utilisateur ?
    </p>
    <div class="flex justify-end mt-6 space-x-3">
      <button (click)="showConfirmationModal = false"
        class="px-4 py-2 text-gray-700 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-300">
        Annuler
      </button>
      <button (click)="changeState(selectedUser.id)"
        class="px-4 py-2 text-white bg-red-600 border border-red-700 rounded-lg hover:bg-red-700">
        Confirmer
      </button>
    </div>
  </div>
</div>
